<template>
  <div class="form-group theme-search-area-options-list">
    <label>{{ label }}<template v-if="required">*</template></label>
    &nbsp;
    <div
      class="btn-group theme-search-area-options-list">
      <p-radio
        v-model="modelField"
        v-for="(option, index) in options"
        :key="`radio-field-${index}`"
        :name="name"
        :value="option.value"
        v-validate="required ? validate : ''"
        class="p-default p-round p-smooth p-plain"
        color="primary-o">&nbsp;{{ option.label }}</p-radio>
    </div>
    <span
      v-if="submitted && errors.first(name)"
      class="theme-form-error-message clearfix">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
export default {
  inject: [ '$validator' ],
  props: [
    'label',
    'required',
    'name',
    'validate',
    'submitted',
    'field',
    'options'
  ],
  watch: {
    modelField (data) {
      this.$emit('update:field', data)
    },
    field (data) {
      this.modelField = data
    }
  },
  data () {
    return {
      modelField: null
    }
  },
  mounted () {
    this.modelField = this.field
  }
};
</script>

<style scoped>
.pretty {
  line-height: 1.15;
}
</style>
